<template>
  <div>
    <h6>{{title}}</h6>

    <ul class="products product-collection product-collection--sidebar">
        <product-card
          :product=product
          :listname=title
          :position=index+1
          :reco=reco
          size='small'
          :hidePreferences="true"
          v-bind:key="index"
          v-for="(product, index) in productResults">
        </product-card>
    </ul>

  </div>
</template>

<script>
import ProductCard from './ProductCard'
import axios from 'axios'
import vue from 'vue'

export default {
  name: 'ProductCollectionSidebar',
  props: {
    title: {
      type: String
    },
    products: {
      type: Array,
      required: true
    }
  },
  components: {
    'product-card': ProductCard
  },
  data () {
    return {
    }
  },
  computed: {
    productResults () {
      return this.products
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/lib";

h6 {
  font-size: 14px;
  font-weight: bold;
}

.product-collection--sidebar {
  margin-left: $padding-standard * -1;
  margin-right: $padding-standard * -1;
  overflow-y: auto;
  max-height: 560px; // limit to 4.5 products then scroll
}

li {
  border-bottom: 1px solid #eee;

  &:last-child{
    border-bottom: none;
  }
}
</style>
